import { ChevronLeft } from "lucide-react";
import { FC, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "~/components/ui/button";
import { ROUTES, useSettingsParams } from "~/helpers";
import { trackEvent } from "~/utils/analytics";
import { NavMenu } from "./NavMenu";
import { SettingsMenuItem } from "./types";

export const SettingsLayout: FC = () => {
  const navigate = useNavigate();
  const { organizationId, settingsItem } = useSettingsParams();

  const handleMenuItemClick = (settingsItem: SettingsMenuItem) => {
    navigate(ROUTES.SETTINGS_ITEM({ organizationId, settingsItem }));
  };

  useEffect(() => {
    if (!settingsItem) {
      navigate(
        ROUTES.SETTINGS_ITEM({ organizationId, settingsItem: "account" })
      );
    }
  }, [settingsItem]);

  const availableMenuItems: SettingsMenuItem[] = [
    "account",
    "appearance",
    "organization",
    "team",
    "categoriesManagement",
    "knowledge",
    "reports",
    "usage",
    "analytics",
    "productivity",
    "developers",
    "archived",
  ];

  const handleBack = () => {
    trackEvent({ eventName: "app/settings_account/cases.button/click" });
    navigate("..");
  };

  return (
    <div className="p-6">
      <div className="flex items-start mb-6">
        <div className="flex gap-4 items-center">
          <Button variant="secondary" size="icon" onClick={handleBack}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <h3 className="text-2xl font-bold">
            <FormattedMessage id="settings" defaultMessage={"Settings"} />
          </h3>
        </div>
      </div>
      <div className="flex gap-4 items-start">
        <NavMenu
          activeItem={settingsItem}
          onItemClick={handleMenuItemClick}
          availableMenuItems={availableMenuItems}
        />
        <Outlet />
      </div>
    </div>
  );
};
